import { createContext, PropsWithChildren, useContext } from "react";
import { useForm, UseFormReturn } from "react-hook-form";
import { Gender } from "../Services/firebase";

export type StudentFormData = {
  firstName: string;
  lastName: string;
  nationality: string;
  homeSpokenLanguage: string;
  dateOfBirth: Date;
  gender: Gender;
  specialRequirements: string;
  lastSchoolAttended: string | undefined;
  leavingCertificate: FileList | undefined;
  address: string;
  emergencyContactName: string;
  emergencyContactNumber: string;
  doctorFullName: string;
  doctorContactNumber: string;
  doctorHospitalName: string;
  passportPicture: FileList;
  birthCertificate: FileList;
  passportFrontPage: FileList;
  passportLastPage: FileList;
  drcVisa: FileList;
  acknowledgement: boolean;
  motherFullName: string;
  motherContactNumber: string;
  motherEmail: string;
  motherQualification: string;
  fatherFullName: string;
  fatherContactNumber: string;
  fatherEmail: string;
  fatherQualification: string;
};

type ContextValue = {
  form: UseFormReturn<StudentFormData, any, StudentFormData>;
};

const studentFormDataContext = createContext<ContextValue>(undefined!);

export const StudentFormDataProvider = ({ children }: PropsWithChildren) => {
  const form = useForm<StudentFormData>();

  return <studentFormDataContext.Provider value={{ form }}>{children}</studentFormDataContext.Provider>;
};

export const useStudentForm = () => {
  const studentFormContext = useContext(studentFormDataContext);
  if (studentFormContext == null)
    throw Error("Student Data Form context must be defined when calling useStudentForm.");

  return studentFormContext.form;
};
